import { render, staticRenderFns } from "./TransactionsOpeningBalance.vue?vue&type=template&id=3a0d7603&"
import script from "./TransactionsOpeningBalance.vue?vue&type=script&lang=js&"
export * from "./TransactionsOpeningBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports